// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"51":"18c3bcc0be0e84d3344e","540":"f63e0162938bf7365441","543":"48e466da8fb3bc1e3b0c","648":"12a88dcbcb5dd081fe99","676":"69b24ae377b0d8f494b7","924":"9f7599e99e013db2f695","959":"8c359aeea9db7f649c62","961":"3602ca073f1e9a742719"}[chunkId] + ".js";
};